module.exports = __webpack_public_path__ + "img/make_model.5c152a7c.png";